<template>
  <div>
    <v-dialog scrollable v-model="showGoDialog" max-width="600px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ $t("DailyKM") }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="text-center">
                  <v-autocomplete
                    v-model="selected.vehicleType" 
                    v-bind:label="$t('Vehicle Type')"
                    :items="vehicleTypeList"
                    item-text="label"
                    item-value="value"
                    filled
                    required
                    :rules="requiredRules"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="text-center">
                  <v-text-field
                    v-model="selected.startKM"
                    v-bind:label="$t('Start') + ' KM'"
                    :type="'number'"
                    required
                    :rules="[kmNumRules]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <template v-if="selected">
                <v-row>
                  <v-col cols="12" sm="12" class="text-center">
                    <gennera-picture-input
                      :crop="false"
                      class="my-picture-input"
                      ref="pictureInputStartPhoto"
                      width="500"
                      height="300"
                      size="5"
                      :prefill="
                        getImageUri(
                          selected.startPhoto.static
                            ? selected.startPhoto.static
                            : null
                        )
                      "
                      accept="image/jpeg,image/png"
                      button-class="btn btn-outline-info"
                      aspect="Landscape"
                      :customStrings="{
                        upload: this.$t('uploading_image'),
                        change: this.$t('change'),
                        tap: 'toma una foto'
                      }"
                      @change="onPictureStartPhoto"
                      :capture="`camera`"
                    >
                    </gennera-picture-input>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click.stop="showGoDialog = false"
            >
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              :loading="isSaving"
              @click="checkOneAwayFromHome(selected)"
              ref="btnSave"
            >
              {{ $t("save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <DialogCompanyCarReason
      v-model="showCompanyCarReasonDialog"
      @cancel="isSaving = false"
      @ok="handleCompanyCarReason"
      ref="companyCarReasonDialog"
    />
    <v-dialog scrollable v-model="showOneAwayFromHomeDialog" max-width="450px">
      <v-form ref="formOneAway" v-model="valid" lazy-validation>
        <v-card v-if="selectedOneAway">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="text-center">
                  <span
                    >Estas a más de 5KM del punto habitual de inicio de ruta.
                    Escribe la dirección donde inicias la ruta.</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="selectedOneAway.address"
                    v-bind:label="$t('address')"
                    v-if="this.isManualAddress"
                    outlined
                    class="editpos_input"
                    :readonly="this.isManualAddress"
                  ></v-text-field>
                  <input
                    v-model="selectedOneAway.address"
                    type="text"
                    :placeholder="$t('address')"
                    ref="googleaddressbar"
                    class="googleAddressFinder pac-target-input"
                    autocomplete="off"
                    required
                    :rules="[
                      !this.manualData ? [
                        v => !!v || 'Address is required.', // Ensures the field is not empty
                        v =>
                          (v && v.trim() !== '') ||
                          'Address cannot be just spaces.' // Ensures the field is not just spaces
                      ] : []
                    ]"
                    v-show="!this.isManualAddress"
                    :readonly="this.isManualAddress"
                  />
                </v-col>
                <!-- Error message for Google Places input -->
                <div
                  v-if="!this.isManualAddress && showAddressError"
                  class="v-messages error--text"
                >
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      La dirección es obligatoria.
                    </div>
                  </div>
                </div>
              </v-row>

              <v-row class="mb-1" v-if="manualData" v-show="isManualAddress">
                <v-col cols="12" sm="12" md="12">
                  <h6 class="my-2">
                    Introduce manualmente la nueva dirección:
                  </h6>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="manualData.address"
                        v-bind:label="$t('address')"
                        required
                        :rules="this.isManualAddress ? requiredRules : []"
                      ></v-text-field
                    >
                  <!-- Error message for Google Places input -->
                <div
                  v-if="this.isManualAddress && showAddressError"
                  class="v-messages error--text"
                >
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      La dirección es obligatoria.
                    </div>
                  </div>
                </div>
                  </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" offset-sm="0" md="12">
                  <div class="text-right">
                    <a style="color: #1976d2;" @click="toggleCantfindAddress">
                      La dirección no sale
                    </a>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12" class="text-center">
                  <span>Puedes indicar el motivo?</span>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="selectedOneAway.motivo"
                    v-bind:label="'Motivo'"
                    required
                    :rules="[
                      v => !!v || 'Motivo is required.', // Ensures the field is not empty
                      v =>
                        (v && v.trim() !== '') ||
                        'Motivo cannot be just spaces.' // Ensures the field is not just spaces
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click.stop="showOneAwayFromHomeDialog = false"
            >
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              :loading="isSaving"
              @click="onClickOneAwayFromHome(selected)"
              ref="btnSave"
            >
              {{ $t("save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import _ from "lodash";
import PictureInput from "vue-picture-input";
import moment from "moment";
import { mapGetters } from "vuex";
import GenneraPictureInput from "@/components/GenneraPictureInput.vue";
import haversine from "haversine-distance";
import DialogCompanyCarReason from "./DialogCompanyCarReason.vue";

export default {
  name: "DialogStartKM",
  components: {
    PictureInput,
    GenneraPictureInput,
    DialogCompanyCarReason
  },
  props: [
    "value",
    "vehicleTypeList",
    "session",
    "current_km_data",
    "mainRoute",
    "currentPosition"
  ],
  data: function() {
    return {
      selected: null,
      valid: true,
      requiredRules: [v => !!v || "Required"],
      kmNumRules: v => {
        if (!isNaN(parseFloat(v)) && v >= 0) return true;
        return "Este campo debe estar por encima de 0";
      },
      isSaving: false,
      isSelecting: false,
      defaultButtonText: "Select ...",
      showOneAwayFromHomeDialog: false,
      selectedOneAway: null,
      isManualAddress: false,
      addressAutoComplete: null,
      isTooFarSelectedAddress: false,
      googleAddressPt: null,
      manualData: null,
      showAddressError: false,
      fromFinishRoute: false,
      showCompanyCarReasonDialog: false
    };
  },
  computed: {
    ...mapGetters("myroute", ["deviceInformation"]),
    ...mapGetters("auth", ["user"]),
    buttonText() {
      return this.isSelecting ? "Uploading..." : this.defaultButtonText;
    },
    showGoDialog: {
      get() {
        this.init();
        return this.value;
      },
      set(value) {
        if (!value) {
          // Reset fromFinishRoute flag when dialog closes
          this.fromFinishRoute = false;
        }
        this.$emit("input", value);
      }
    }
  },
  methods: {
    moment,
    async toggleCantfindAddress() {
      this.isManualAddress = !this.isManualAddress;
      this.showAddressError = false;
      if (this.isManualAddress) {
        this.manualData = {
          town: "",
          postalCode: "",
          address: "",
          addressObservation: ""
        };
      }
    },
    onGoogleMapInit() {
      this.$nextTick(() => {
        setTimeout(() => {
          const input = this.$refs.googleaddressbar;
          if (input && window.google?.maps?.places) {
            // Avoid re-initializing
            this.addressAutoComplete = new window.google.maps.places.Autocomplete(
              input
            );
            this.addressAutoComplete.addListener(
              "place_changed",
              this.placeChangedListener
            );
          } else {
            console.warn("Google Maps library not loaded or input missing");
          }
        }, 800); // Delay to allow dialog and transitions to complete
      });
    },
    getImageUri(imgStatic) {
      if (imgStatic && imgStatic?.type === "file") {
        return ApiService.getFileUri(imgStatic);
      }
      return ApiService.getImageUri(imgStatic);
    },
    createSelectedModel(item) {
      let model = {
        id: _.get(item, "id"),
        vehicleType: _.get(item, "vehicleType"),
        startKM: _.get(item, "startKM"),
        startPhoto: {
          img: null,
          static: _.get(item, "startPhoto")
        }
      };
      if (!model.vehicleType) model.vehicleType = "OWNVEHICLE";
      return model;
    },
    onPictureStartPhoto() {
      this.selected.startPhoto.img = this.$refs["pictureInputStartPhoto"].file;
    },
    async saveForEmptyKM() {
      this.selected = this.createSelectedModel(this.current_km_data);
      if (this.selected) {
        this.selected.startKM = 0;
        let body = _.omit(this.selected, ["startPhoto"]);
        body.userId = this.session.userId;
        body.date = this.session.date;
        let logDate = moment(new Date())
          .local()
          .format("YYYY-MM-DD");
        body = {
          ...body,
          isStarted: true,
          isPaused: false,
          logDate,
          currentDate: new Date(),
          endableMoment: new Date(logDate + " 23:59:59"),
          routeId: this.mainRoute.id
        };
        let response = await ApiService.post(`worksession/save_start_km`, body);
        return response;
      }
      return null;
    },

    placeChangedListener() {
      var address = this.addressAutoComplete.getPlace();
      console.log(address);
      if (address && address.address_components) {
        let addressDetail = {
          address: address.formatted_address,
          town: null,
          postalCode: null,
          latitude: null,
          longitude: null
        };
        // types - postal_code
        let postal_code_item = address.address_components.filter(el =>
          el.types.includes("postal_code")
        );
        if (postal_code_item && postal_code_item.length > 0) {
          addressDetail.postalCode = postal_code_item[0].long_name;
        }
        // town types - locality
        let town_item = address.address_components.filter(el =>
          el.types.includes("locality")
        );
        if (town_item && town_item.length > 0) {
          addressDetail.town = town_item[0].long_name;
        }

        this.selectedOneAway = { ...this.selectedOneAway, ...addressDetail };
        this.showAddressError = false;
      }
    },

    async getLatLngFromPostalCode(postalCode) {
      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: postalCode }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            const lat = location.lat();
            const lng = location.lng();
            resolve({ lat, lng });
          } else {
            resolve(null);
          }
        });
      });
    },
    async onClickOneAwayFromHome(item) {
      if (this.$refs.formOneAway.validate()) {
        let address = this.isManualAddress
          ? this.manualData?.address
          : this.selectedOneAway?.address;
        let motivo = this.selectedOneAway.motivo;

        // Validate address
        if (!address || address.trim() === "") {
          this.showAddressError = true;
          return;
        } else {
          this.showAddressError = false;
        }

        let selectedItem = {};
        if (this.isManualAddress) {
          selectedItem = {
            ...item,
            motivo: this.selectedOneAway.motivo,
            address: this.manualData.address
          };
        } else {
          selectedItem = {
            ...item,
            motivo: this.selectedOneAway.motivo,
            address: this.selectedOneAway.address
          };
        }
        this.onSaveClick(selectedItem);
      }
    },
    async handleCompanyCarReason(reason) {
      this.selected.companyCarReason = reason;
      this.checkDistanceAndProceed(this.selected);
    },
    async checkOneAwayFromHome(item) {
      let response;
      try{
      if (this.$refs.form.validate()) {
        response = await ApiService.postNotAlert(
          "worksession/check_vehicle_type",
          { vehicle_type: item.vehicleType }
        );

        if (response.success === false) {
          this.showCompanyCarReasonDialog = true;
        } else {
          this.checkDistanceAndProceed(item);
        }
      }
      }catch(error) {
        if(error && error.data && error?.data?.errors && error?.data?.errors?.wrong_vehicle_selected) {
          this.showCompanyCarReasonDialog = true;
        }
        else {
          logError("Something went wrong.");
        }
      }
     
    },
    async checkDistanceAndProceed(item) {
      if (this.currentPosition) {
        let distance = null;
        let posLocationPt = {
          lat: this.currentPosition.latitude,
          lng: this.currentPosition.longitude
        };
        let userLocationPt = await this.getLatLngFromPostalCode(
          this.user.postalCode
        );
        if (userLocationPt) {
          distance = haversine(posLocationPt, userLocationPt);
        }
        // [Modified by E2logy]: Previous implementation was incorrectly comparing distance
        // Previous code implementation was checking the distance against 1 KM directly, but the
        // library used for distance calculations returns the distance in meters.
        // Changed to check if the distance is greater than or equal to 5000 meters (5 KM) [Previous was 1000 meters (1 KM)]
        if (
          this.user.liquidationType === "TOTAL_KM" &&
          distance &&
          distance >= 5000 // 5 KM
        ) {
          this.showOneAwayFromHomeDialog = true;
          this.selectedOneAway = {
            fiscalTown: null,
            fiscalPostalCode: null,
            fiscalAddress: null,
            postalCode: null,
            addressObservation: null,
            town: null,
            vatNumber: null,
            latitude: null,
            longitude: null,
            address: null,
            motivo: null
          };
          this.onGoogleMapInit();
        } else {
          this.onSaveClick(item);
        }
      } else {
        this.onSaveClick(item);
      }
    },
    async onSaveClick(item) {
      if (this.$refs.form.validate()) {
        try {
          this.isSaving = true;
          let body = _.omit(item, ["startPhoto"]);
          body.userId = this.session.userId;
          body.date = this.session.date;
          body.motivo = item.motivo || null;
          body.address = item.address || null;
          let imgStart = item.startPhoto.img;
          if (imgStart) {
            let { data } = await ApiService.uploadImage(imgStart);
            body.startPhotoId = data.id;
          } else if (!item.startPhoto.static) {
            logError("Se requiere una foto de inicio.");
            this.isSaving = false;
            return;
          }
          let logDate = moment(new Date())
            .local()
            .format("YYYY-MM-DD");
          body = {
            ...body,
            isStarted: true,
            isPaused: false,
            logDate,
            currentDate: new Date(),
            endableMoment: new Date(logDate + " 23:59:59"),
            routeId: this.mainRoute.id
          };
          let response = await ApiService.post(
            `worksession/save_start_km`,
            body
          );
          // Add fromFinishRoute flag to response
          response.fromFinishRoute = this.fromFinishRoute;
          this.$emit("savingStartKM", response);
          this.isSaving = false;
        } catch (error) {
          this.isSaving = false;
        }
      }
    },
    init() {
      this.selected = this.createSelectedModel(this.current_km_data);
      // Don't reset fromFinishRoute here as it might be set from parent
    }
  },
  async updated() {},
  async mounted() {
    this.init();
  }
};
</script>

<style>
input.googleAddressFinder {
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition-property: height, min-height;
  margin-top: 16px;
  font-size: 16px;
  height: 33px;
}

.v-messages__message {
  font-size: 12px;
  line-height: 14px;
  margin-top: 4px;
  margin-left: 12px;
}
/* Error message styling to match Vuetify */
.v-messages.error--text {
  color: #ff5252 !important;
}
</style>
